import { User } from '@/type';
import { type as accountType } from '@/iam/account';

export function getAccountType(user: User): number {
  if (user.accountId) return accountType.CUSTOMER;
  if (user.clientId) return accountType.CLIENT;
  throw new Error(`User ${user.id} account type could not be determined.`);
}
